import { Fragment, type FC } from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { TextLabel } from 'app/KinerjaKSPage/components/EvaluationResult/components/Texts'
import Grid from 'app/KinerjaKSPage/components/EvaluationResult/components/Grid'

type EvaluationResultSummaryProps = React.HTMLAttributes<HTMLDivElement> & {
  data: {
    predicates?: Array<{
      label: string
      description: string
      value?: string
    }>
    summary?: {
      label: string
      value?: string
    }
  }
}

const EvaluationResultSummary: FC<EvaluationResultSummaryProps> = ({
  data,
  ...props
}) => {
  const { predicates, summary } = data

  if (!predicates && !summary) return null

  const PredikatKinerja = () => {
    return (
      <>
        <div className="mt-3 border border-gray-30 rounded-lg">
          {/* Predicates */}
          {!!predicates && (
            <div className="py-4 px-6 space-y-7">
              {predicates?.map((predicate, index) => (
                <Fragment key={index}>
                  <Grid
                    childrenLeft={
                      <>
                        <TextLabel>{predicate.label}</TextLabel>
                        <Text variant="body-sm" color="disabled">
                          {predicate.description}
                        </Text>
                      </>
                    }
                    childrenRight={
                      <TextLabel className="!text-subdued">
                        {predicate?.value}
                      </TextLabel>
                    }
                  />
                </Fragment>
              ))}
            </div>
          )}

          {/* Summary */}
          {!!summary && (
            <div
              className={clsx('py-4 px-6 bg-blue-5 rounded-b-lg', {
                'rounded-t-lg': !predicates,
              })}
            >
              <Grid
                childrenLeft={
                  <Text variant="heading-md" className="flex-1">
                    {summary?.label}
                  </Text>
                }
                childrenRight={
                  <TextLabel className="!text-subdued flex-none">
                    {summary?.value}
                  </TextLabel>
                }
              />
            </div>
          )}
        </div>
      </>
    )
  }

  return (
    <>
      <div className="mt-3" {...props}>
        {(!!predicates || !!summary) && (
          <>
            <TextLabel>Predikat Kinerja</TextLabel>
            <PredikatKinerja />
          </>
        )}

        <div className="mt-9 space-y-4">
          <div>
            <Text variant="body-sm-bold">Perlu diketahui:</Text>
            <ol className="list-decimal ml-4">
              {/* TODO Update this month name according to the period */}
              <Text as="li" variant="body-sm">
                Dokumen ini diberikan pada bulan Juni dan Desember di Ruang GTK.
              </Text>
              <Text as="li" variant="body-sm">
                Dokumen ini digunakan Kemendikbudristek untuk keperluan analisis
                capaian dan upaya peningkatan kinerja.
              </Text>
              <Text as="li" variant="body-sm">
                Dokumen ini menjadi salah satu komponen untuk memproses Predikat
                Kinerja tahunan yang akan dialirkan ke e-Kinerja BKN (Badan
                Kepegawaian Negara).
              </Text>
            </ol>
          </div>

          <div>
            <Text variant="body-sm-bold">Catatan:</Text>
            <ol className="list-none">
              <Text as="li" variant="body-sm">
                Dokumen ini tidak perlu ditandatangani.
              </Text>
            </ol>
          </div>
        </div>
      </div>
    </>
  )
}
export default EvaluationResultSummary
